<aura-dialog-layout title="Refuser le document" [hideCancel]="true">
  <div dialog-content class="flex flex-col gap-4 py-2">
    <!-- Document Info Card -->
    <div
      class="flex items-center gap-3 p-3 rounded-xl bg-ruby-2/60 border border-ruby-4 text-ruby-12 text-sm"
    >
      <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-ruby-3 text-ruby-11">
        <mat-icon svgIcon="circle-alert" />
      </div>
      <div class="min-w-0 flex-1">
        <div class="font-medium truncate">{{ data.documentName || 'Document' }}</div>
        <p class="text-xs text-ruby-10 m-0">
          Ce motif sera visible par le propriétaire pour lui permettre de corriger son document.
        </p>
      </div>
    </div>

    <!-- Quick Presets -->
    <div class="flex flex-col gap-2">
      <span class="text-xs font-semibold text-gray-11 uppercase tracking-wider"> Motifs fréquents </span>
      <div class="flex flex-wrap gap-2">
        @for (preset of presetReasons; track preset) {
          <button
            type="button"
            (click)="selectPreset(preset)"
            class="px-3 py-1.5 rounded-lg text-xs font-medium border transition-colors text-left"
            [class]="
              selectedPreset() === preset
                ? 'bg-ruby-3 text-ruby-11 border-ruby-7 shadow-2xs'
                : 'bg-gray-2 text-gray-12 border-gray-5 hover:bg-gray-3'
            "
          >
            {{ preset }}
          </button>
        }
        <button
          type="button"
          (click)="selectCustom()"
          class="px-3 py-1.5 rounded-lg text-xs font-medium border transition-colors text-left"
          [class]="
            selectedPreset() === 'other'
              ? 'bg-ruby-3 text-ruby-11 border-ruby-7 shadow-2xs'
              : 'bg-gray-2 text-gray-12 border-gray-5 hover:bg-gray-3'
          "
        >
          Autre motif personnalisé...
        </button>
      </div>
    </div>

    <!-- Reason text area -->
    <div class="flex flex-col gap-1.5">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Précision du motif de refus</mat-label>
        <textarea
          matInput
          rows="3"
          placeholder="Ex: Le document est flou et la date n'est pas lisible..."
          [ngModel]="reasonText()"
          (ngModelChange)="reasonText.set($event)"
          required
        ></textarea>
      </mat-form-field>
    </div>
  </div>

  <div dialog-actions class="flex w-full justify-end gap-3 pt-2">
    <button mat-stroked-button type="button" (click)="onCancel()">Annuler</button>
    <button
      mat-flat-button
      type="button"
      class="primary destructive text-white font-medium shadow-xs"
      [disabled]="!reasonText().trim()"
      (click)="onConfirm()"
    >
      <mat-icon svgIcon="circle-alert" />
      <span>Confirmer le refus</span>
    </button>
  </div>
</aura-dialog-layout>
